import Link from "next/link";
import React from "react";

import {
  Breadcrumb,
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Row
} from 'react-bootstrap';

import BreadcrumbItem from '../components/BreadcrumbItem';
import { catalogService } from '../services';

const URL_COMPANIES = '/companies'

export async function getServerSideProps() {
  const data = await catalogService.getCategoriesMap();
  //const industries = await catalogService.getIndustries();
  // const locations = await catalogService.getLocations();

  if (!data) {
    return {
      notFound: true,
    }
  }

  const transformedData = data.map(categoryItem => {
    const locations = categoryItem.locations || {};
    const countries = locations.countries || [];

    const usCountry = countries.find(country => country.code === 'US');
    const usStates = usCountry?.states || [];
    const nonUSCountries = countries.filter(country => country.code !== 'US');

    return {
      ...categoryItem,
      locations: {
        ...locations,
        countries: nonUSCountries,
        usLocations: usStates
      }
    };
  });

  return {
    props: {
      nav: {
        light: true,
        classes: "shadow",
        color: "white",
      },
      title: "Categories",
      canonical: `${process.env.BASE_URL}/categories`,
      meta: "If you need a software development company, Vendorland is the place for you. With over 100 software categories, you are sure to choose the IT services provider you need.",
      //industries: industries.map((industry) => ({ ...industry, query: `?industry=${industry.code}` })),
      // locations: locations.map((location) => ({ ...location, query: `?location=${location.code}` })),
      // locations: locations.map((location) => ({ ...location, query: `/${location.code.toLowerCase() || ''}` })),
      data: transformedData,
    },
  };
}

//
const CategoryCell = (props) => {
  const { label, base_href, items = [], collapse, ...rest } = props;
  const items1 = (items.length > 7) ? items.slice(0, 5) : items;
  const items2 = (items.length > 7) ? items.slice(5) : []

  //  const getLink = (item) => `/top${item.link || base_href}/companies${item.link2 || item.query || ''}`;
  //const getLink = (item) => `${URL_COMPANIES}${item.link || base_href}${item.link2 || item.query || ''}`;
  const getLink = (item) => `${URL_COMPANIES}${item.link || base_href}${item.query || ''}`;

  const renderItem = (item, index) => (
    <div key={index}>
      <li className="mb-1">
        <Link href={getLink(item)} className="category-page-item-link">
          {item.name}
        </Link>
      </li>
      {item.cities?.map((city, cityIndex) => (
        <li key={`${index}-${cityIndex}`} className="mb-1 ms-3">
          <Link href={getLink(city)} className="category-page-item-link">
            {city.name}
          </Link>
        </li>
      ))}
    </div>
  );

  return (
    <React.Fragment>
      {(items.length > 0) && (
        <div>
          <p className="category-column-header mb-1">{label}</p>
          <div className="categories-row-separator my-2" />
          <ul className="list-unstyled mb-0 ms-0 text-sm">
            {items1.map((item, index) => renderItem(item, index))}
            {(items2.length > 0) && (
              <Collapse in={collapse}>
                <div id="example-collapse-text">
                  {items2.map((item, index) => renderItem(item, index))}
                </div>
              </Collapse>
            )}
          </ul>
          {(items2.length > 0) && (
            <div className="mb-4">
              <Button
                aria-expanded={collapse}
                aria-controls="example-collapse-text"
                // color="link"
                variant="link"
                {...rest}
                className="btn-collapse ps-0 text-lowercase"
              >
                {collapse ? `Less ${label}` : `See all ${label}`}
              </Button>

            </div>
          )}
        </div>
      )}
    </React.Fragment>
  )

}

//
const Categories = (props) => {

  const [collapse, setCollapse] = React.useState({ 'CSD': true });
  const [verticalCollapse, setVerticalCollapse] = React.useState(false)
  const [focusCollapse, setFocusCollapse] = React.useState(false)
  const [countryCollapse, setCountryCollapse] = React.useState(false)
  const [platformCollapse, setPlatformCollapse] = React.useState(false)
  const [usLocationsCollapse, setUsLocationsCollapse] = React.useState(false)
  const { data } = props;

  const subsystems = (subcategories) => [].concat.apply([], subcategories.map((item) => item.subsystems));

  const toggleCollapse = (name) => {
    setCollapse({ ...collapse, [name]: !collapse[name] });
  };

  return (
    <React.Fragment>
      <section className="py-5">
        <Container>
          <Breadcrumb listProps={{ className: "ps-0 justify-content-start" }}>
            <BreadcrumbItem href="/">Home</BreadcrumbItem>
            <BreadcrumbItem active>All categories</BreadcrumbItem>
          </Breadcrumb>
          <Row className="px-xl-10">
            <Col lg="12" xl="12" className="align-self-center mb-3 mb-lg-0">
              <div id="accordion" className="docs-item element">
                <div className="mt-0">
                  <div role="tablist">
                    <h1 className="hero-heading mb-4">All categories</h1>
                    {data.map((item, index) =>
                      <Card key={index} className="border-0 shadow mb-4 mb-lg-4">
                        <Card.Header id="headingOne" role="tab" onClick={() => toggleCollapse(item.category.code)} className="bg-primary-80 border-0 py-0">
                          <span
                            style={{ cursor: "pointer" }}
                            className="btn-collapse ps-0 accordion-link"
                            aria-expanded={collapse[item.category.code]}
                          >{` ${item.category.name}`}
                          </span>
                        </Card.Header>
                        <Collapse in={collapse[item.category.code]}>
                          <Card.Body>
                            <Row>
                              <Col lg="2">
                                <CategoryCell
                                  label="Focus areas"
                                  items={item.subcategories}
                                  collapse={focusCollapse}
                                  onClick={() => setFocusCollapse(!focusCollapse)}
                                />
                                <div className="mt-3">
                                  <CategoryCell
                                    label="Systems"
                                    items={subsystems(item.subcategories)}
                                  />
                                </div>
                              </Col>
                              <Col lg="2">
                                <CategoryCell
                                  label="Technology stack"
                                  items={item.platforms}
                                  base_href={item.category.link}
                                  collapse={platformCollapse}
                                  onClick={() => setPlatformCollapse(!platformCollapse)}
                                />
                              </Col>
                              <Col lg="3">
                                <CategoryCell
                                  label="Industries in demand"
                                  items={item.industries}
                                  base_href={item.category.link}
                                  collapse={verticalCollapse}
                                  onClick={() => setVerticalCollapse(!verticalCollapse)}
                                />
                              </Col>
                              <Col lg="2">
                                <CategoryCell
                                  label="Global Locations"
                                  items={item.locations.countries || []}
                                  base_href={item.category.link}
                                  collapse={countryCollapse}
                                  onClick={() => setCountryCollapse(!countryCollapse)}
                                />
                              </Col>
                              <Col lg="3">
                                <CategoryCell
                                  label="US States & Cities"
                                  items={[...(item.locations.usLocations || [])].sort((a, b) => a.name.localeCompare(b.name))}
                                  base_href={item.category.link}
                                  collapse={usLocationsCollapse}
                                  onClick={() => setUsLocationsCollapse(!usLocationsCollapse)}
                                />
                              </Col>
                            </Row>
                            <Row>
                              <Col className="text-center text-lg-center">
                                <Button
                                  href={`${URL_COMPANIES}${item.category.link}`}
                                  variant="outline-secondary"
                                  size="sm">
                                  {`See all in ${item.category.name}`}
                                </Button>
                              </Col>
                            </Row>
                          </Card.Body>
                        </Collapse>
                      </Card>
                    )}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  )
}

export default Categories;
